// extracted by mini-css-extract-plugin
export default {"root":"_1in0d","normal":"_1un43","tier-link":"z2U1r","tierLink":"z2U1r"};